import FormEditorContainerNew from './src/main'

FormEditorContainerNew.install = function (Vue) {
  Vue.component(FormEditorContainerNew.name, FormEditorContainerNew)
}

export default FormEditorContainerNew
